"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var i18n_1 = __importDefault(require("../i18n"));
var VerifyPaymentCardStrings = {
    billingAddress: function () { return i18n_1["default"].t('verifyPaymentCardStrings_billingAddress'); },
    cardDetails: function () { return i18n_1["default"].t('verifyPaymentCardStrings_cardDetails'); },
    cardExpiration: function () { return i18n_1["default"].t('verifyPaymentCardStrings_cardExpiration'); },
    cardReentryDescription: function () {
        return i18n_1["default"].t('verifyPaymentCardStrings_cardReentryDescription');
    },
    cardReentryError: function () { return i18n_1["default"].t('verifyPaymentCardStrings_cardReentryError'); },
    cardVerifyDescription: function () {
        return i18n_1["default"].t('verifyPaymentCardStrings_cardVerifyDescription');
    },
    cardVerifyNote: function () { return i18n_1["default"].t('verifyPaymentCardStrings_cardVerifyNote'); },
    cardReentryTitle: function () { return i18n_1["default"].t('verifyPaymentCardStrings_cardReentryTitle'); },
    cardVerifyTitle: function () { return i18n_1["default"].t('verifyPaymentCardStrings_cardVerifyTitle'); },
    cardZipCode: function () { return i18n_1["default"].t('verifyPaymentCardStrings_cardZipCode'); },
    contactSupport: function () { return i18n_1["default"].t('verifyPaymentCardStrings_contactSupport'); },
    contactSupportSuffixMsg: function () {
        return i18n_1["default"].t('verifyPaymentCardStrings_contactSupportSuffixMsg');
    },
    invalid: function () { return i18n_1["default"].t('verifyPaymentCardStrings_invalid'); },
    note: function () { return i18n_1["default"].t('verifyPaymentCardStrings_note'); },
    or: function () { return i18n_1["default"].t('verifyPaymentCardStrings_or'); },
    paymentCard: function () { return i18n_1["default"].t('verifyPaymentCardStrings_paymentCard'); },
    required: function () { return i18n_1["default"].t('verifyPaymentCardStrings_required'); },
    saveCard: function () { return i18n_1["default"].t('verifyPaymentCardStrings_saveCard'); },
    unableToVerifyPleaseTryAgain: function () {
        return i18n_1["default"].t('verifyPaymentCardStrings_unableToVerifyPleaseTryAgain');
    },
    verifyAndPlaceOrder: function () {
        return i18n_1["default"].t('verifyPaymentCardStrings_verifyAndPlaceOrder');
    },
    verifyWithADifferentCard: function () {
        return i18n_1["default"].t('verifyPaymentCardStrings_verifyWithADifferentCard');
    }
};
exports["default"] = VerifyPaymentCardStrings;
